import templateUrl from './our-staff-list.html';
import clone from 'lodash/clone';

export const ourStaffListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},
	templateUrl,
	controller: class OurStaffListComponent {

		constructor($state, ModalService, AboutUsService, toastr, ApiService, DynamicMenusService, SlugService) {
			'ngInject';

			this.$state = $state;
			this.modalService = ModalService;
			this.apiService = ApiService;
			this.aboutUsService = AboutUsService;
			this.toastr = toastr;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		$onInit() {
			this.details = this.aboutUsService.getOurStaffDetails(this.details);
		}

		routeAddPageUrl() {
			const url = this.slugService.getAddPageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}

		routeSequencePageUrl() {
			const url = this.slugService.getSequencePageURL(this.slugUrl);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		routeEditPageUrl(slug) {
			const url = this.slugService.getEditPageURL(slug);

			this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
		}

		onDeleteStaff(slug) {
			this.modalService.open({
				details: {
					bodyMessage: 'Are you sure you want to delete staff?'
				},
				buttons: [{
					name: 'No'
				}, {
					name: 'Yes',
					isPrimary: true,
					action: _onDelete.bind(this, slug)
				}]
			});

			function _onDelete(slug) {
				this.dynamicMenusService.deleteMenuDetailsByUrl(`${slug}/delete`)
					.then((details) => {
						this.toastr.success('staff deleted succesfully');
						this.$state.reload();
					}).catch((error) => {
						this.toastr.error(error);
					});
			}
		}

		_getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/Staff_default.jpg';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/our-staff/our-staff-list/our-staff-list.component.js